import * as React from "react"
import {Box, Typography} from "@mui/material"

import {BadgeVariant} from "@components";
import {useUserApp} from "@hooks";
import { PricingPriceBlock } from "../../../../@components"

export default function unifiedPriceColumn({ label, priceComponents, minWidth = 120}) {
    return {
        name: 'prices', label,
        options: {
            filter: false,
            customBodyRowRenderLite: (value, dataRow) => <PriceColumnRenderer
                dataRow={dataRow}
                priceComponents={priceComponents}
                minWidth={minWidth}
            />
        }
    }
}

const PriceColumnRenderer = ({ dataRow, priceComponents, minWidth }) => {
    if (!priceComponents || priceComponents.length === 0) {
        return <></>
    }

    const { userGroupByProductID, userUseRRSP } = useUserApp()

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {priceComponents.map((component, index) => {
                const {
                    title,
                    priceKey,
                    diffKey,
                    retailerKey,
                    stockKey,
                    siteIDKey,
                    productIDKey,
                    numVariants,
                    showStock = null,
                } = component

                const diffPrice = diffKey ? dataRow[diffKey] : null
                const retailerPrice = retailerKey ? dataRow[retailerKey] : null
                const stock = showStock && stockKey ? dataRow[stockKey] : null
                const productKey = productIDKey ? dataRow[productIDKey] : null

                return <Box
                        key={title}
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            ...(index < priceComponents.length - 1 && {
                                marginBottom: 1,
                                borderBottom: '1px solid rgba(54, 69, 79, 0.1)',
                            }),
                        }}
                    >
                        <Typography variant="subtitle2" sx={{ alignContent: 'center', paddingRight: 1 }}>
                            {title}
                        </Typography>
                        <PricingPriceBlock
                            price={dataRow[priceKey]}
                            currency={dataRow['currency']}
                            diff={diffPrice}
                            retailer={retailerPrice}
                            siteID={dataRow[siteIDKey]}
                            productID={productKey}
                            stock={stock}
                            propsContainer={{ sx: { minWidth } }}
                            userUseRRSP={userUseRRSP}
                            reverse
                        />
                    {
                        !userGroupByProductID &&
                        (
                            showStock === false ||
                            (showStock === true && !!stock)
                        ) &&
                        <BadgeVariant numVariants={dataRow[numVariants]} />
                    }
                    </Box>
            })}
        </Box>
    )
}
